import {
  IconCreditCard,
  IconInfoSquareRoundedFilled,
} from "@tabler/icons-react";
import { IonHeader, IonToolbar } from "@ionic/react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Settings } from "../interfaces";
import classNames from "classnames";
import "./NavBanner.css";
import { computePlanUsage } from "./usage/plan";

const NavBanner: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { mode, hide } = props;
  const { isLimitReached, isLimitApproaching, isPastDue } = computePlanUsage(
    props.settings
  );
  const { retries } = props.settings.status.payment;

  const channelStatus = props.settings.onboardingList.find(
    (item) => item.name === "channel"
  );
  const isNotDoneChannel = channelStatus ? channelStatus.done === false : false;
  const show =
    (isLimitReached || isLimitApproaching || isPastDue || isNotDoneChannel) &&
    !hide;

  const icon = isNotDoneChannel ? (
    <IconInfoSquareRoundedFilled size={16} />
  ) : (
    <IconCreditCard size={16} />
  );

  const linkHref = isNotDoneChannel
    ? "https://cal.com/team/visito/support?duration=30"
    : "/settings/payment";

  const ctaId = isPastDue
    ? "nav.pastDueCTA"
    : isNotDoneChannel
    ? "nav.channelOnboardingCTA"
    : "nav.paymentCTA";

  const messageId = isPastDue
    ? "nav.pastDue"
    : isLimitApproaching && !isLimitReached
    ? "nav.limitApproaching"
    : isNotDoneChannel
    ? "nav.channelOnboarding"
    : "nav.payment";

  const isExternal = isNotDoneChannel; // Only Cal.com is external

  return mode === "desktop" ? (
    !show ? null : (
      <div
        className={classNames("navbanner", {
          warning: isLimitApproaching, // display yellow
          danger: isPastDue || isLimitReached, // Display red
          info: isNotDoneChannel, // Display blue for channel onboarding
        })}
      >
        <div className="navbanner-item">{icon}</div>
        <div className="navbanner-item">
          <span className="fs-2 fw-semibold-1">
            <>
              <FormattedMessage values={{ count: retries }} id={messageId} />{" "}
              {isExternal ? (
                <a
                  href={linkHref}
                  className="link-unset fw-semibold"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id={ctaId} />
                </a>
              ) : (
                <Link to={linkHref} className="link-unset fw-semibold">
                  <FormattedMessage id={ctaId} />
                </Link>
              )}
            </>
          </span>
        </div>
      </div>
    )
  ) : !show ? null : hide ? null : (
    <IonHeader>
      <IonToolbar
        className={classNames("navbanner", {
          warning: isLimitApproaching, // display yellow
          danger: isPastDue || isLimitReached, // Display red
          info: isNotDoneChannel, // Display blue for channel onboarding
        })}
      >
        {isExternal ? (
          <a
            href={linkHref}
            className="link-unset fw-semibold"
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
          >
            <div className="navbanner">
              <div className="navbanner-item">{icon}</div>
              <div className="navbanner-item">
                <FormattedMessage id={messageId} />
              </div>
            </div>
          </a>
        ) : (
          <Link to={linkHref} className="link-unset fw-semibold">
            <div className="navbanner">
              <div className="navbanner-item">{icon}</div>
              <div className="navbanner-item">
                <FormattedMessage id={messageId} />
              </div>
            </div>
          </Link>
        )}
      </IonToolbar>
    </IonHeader>
  );
};

interface ILayoutProps {
  settings: Settings;
  mode: string;
  hide?: boolean;
}

export default NavBanner;
